import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter, Link} from "react-router-dom";
import { Grid} from '@material-ui/core';
import { Add } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import _ from 'lodash';
import moment from "moment";

import { addLoan, getLoansByDealIdAndStatus } from "store/state/loan/loan";

import loanSeniorityTypes from "constants/loanSeniorityTypes"
import { ClosedLoanComponent } from "./ClosedLoanComponent";
import { PaidOffLoanComponent } from "./PaidOffLoanComponent";
import applicationRoles from "constants/applicationRoles";
import loanStatuses from "constants/loanStatuses";

import { ViewHeader } from "../util";
import { StyledActionButton,StyledLinkButton, styles, SectionFragment,SubSectionFragment } from "../styles";
  
class LoanView extends React.Component {
    state = {
        selectedClosedLoan: null,
        selectedPaidOffLoan: null,
        dealId: "free",
        fundId: "free",
        showPaidOffLoans: false,   
    }

    componentWillUnmount(){
        this.props.getLoansByDealIdAndStatus({dealId: null, loanStatusId: loanStatuses.CLOSED_LOAN});
        this.props.getLoansByDealIdAndStatus({dealId: null, loanStatusId: loanStatuses.PAID_OFF});
    }
    componentDidMount = (prevProps, prevState, snapshot) => {
      this.props.getLoansByDealIdAndStatus({dealId: this.props.dealId, loanStatusId: loanStatuses.CLOSED_LOAN});
      const {location, match} = this.props;              
      this.setState({
        dealId: match.params.dealId,
        fundId: match.params.fundId
      })
    }

    componentDidUpdate = () =>{
        const {paidOffLoans, closedLoans} = this.props;

        this.selectInitialClosedLoan(closedLoans);
        this.selectInitialPaidOffLoan(paidOffLoans);
    }
    
    handleLoanSelect = (loanType, loan) => {
        if(loan)
            this.setState({[loanType]: loan});
    }

    showHidePaidOffLoans =()=>{
      this.props.getLoansByDealIdAndStatus({dealId: this.props.dealId, loanStatusId: loanStatuses.PAID_OFF});
        this.setState({
          showPaidOffLoans: !this.state.showPaidOffLoans,      
        });
      }

    selectInitialClosedLoan(sectionLoans) {
        if (!this.state.selectedClosedLoan && sectionLoans) {
            let initialSelectedLoan = sectionLoans[0];
            const filteredSenior = sectionLoans.filter((x) => x.loanSeniorityId === loanSeniorityTypes.SENIOR);
            const filteredMezz = sectionLoans.filter((x) => x.loanSeniorityId === loanSeniorityTypes.SUBORDINATE);
            const filteredSupplemental = sectionLoans.filter((x) => x.loanSeniorityId === loanSeniorityTypes.SUPPLEMENTAL);
            if (filteredSenior.length > 0)
                initialSelectedLoan = filteredSenior[0];
            else if (filteredMezz.length > 0)
                initialSelectedLoan = filteredMezz[0];
            else if (filteredSupplemental.length > 0)
                initialSelectedLoan = filteredSupplemental[0];
            if (initialSelectedLoan) {
                this.handleLoanSelect("selectedClosedLoan",initialSelectedLoan);
            }
        }
    }
    
    selectInitialPaidOffLoan(sectionLoans) {
        if (!this.state.selectedPaidOffLoan && sectionLoans) {            
            let initialSelectedLoan = sectionLoans.sort((a, b) => moment.utc(b.maturityDate).unix() - moment.utc(a.maturityDate).unix())[0];
            this.handleLoanSelect("selectedPaidOffLoan",initialSelectedLoan);
        }
    }

    addNewLoan = () => {
        const { history } = this.props;
        const newLoan = {
            loan: {
                dealId: this.state.dealId,
                loanStatusId: loanStatuses.CLOSED_LOAN,
                loanSeniorityId: loanSeniorityTypes.SENIOR
            },
            callback: () => {
                history.push(`/portfolio/funds/free/deals/${this.state.dealId}/loans/${this.props.savedLoan.id}/loanDetailsPage/1`)
            }
        };
        
        this.props.addLoan(newLoan);
    }


    render() {
        
        const { selectedClosedLoan, selectedPaidOffLoan, fundId, dealId, showPaidOffLoans} = this.state;
        const { closedLoans, paidOffLoans, guestPermissions, authentication } = this.props;        
        const newLoanButton = (!authentication.isGuest) && (<StyledActionButton variant="contained" onClick={this.addNewLoan} id="newLoanButton"><Add />New Loan</StyledActionButton>);
        return ( 
            <SectionFragment>
            <SubSectionFragment>
                <ViewHeader TitleText="Loans" children={newLoanButton} />

            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                <ClosedLoanComponent
                    loans={closedLoans}
                    handleSelect={(loan) => this.handleLoanSelect("selectedClosedLoan",loan)}
                    selectedLoan={selectedClosedLoan}
                    Link={Link}
                    fundId={fundId}
                    dealId={dealId}/>
            </Grid>
            </SubSectionFragment>
            {(!authentication.isGuest || (authentication.isGuest && guestPermissions.accessLevel === "Full")) &&
                <SubSectionFragment>
                    <Grid container direction="row" justify="flex-start" alignItems="center">
                        <Grid item sm={12}>
                            <StyledLinkButton 
                                variant="contained"
                                id="showHidePaidOffLoansButton"
                                onClick={this.showHidePaidOffLoans}>{showPaidOffLoans ? "HIDE" : "SHOW"} PAID OFF LOANS</StyledLinkButton>
                        </Grid>
                    </Grid>
                    {!showPaidOffLoans || 
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                        <PaidOffLoanComponent
                            loans={paidOffLoans}
                            handleSelect={(loan) => this.handleLoanSelect("selectedPaidOffLoan",loan)}
                            selectedLoan={selectedPaidOffLoan}
                            Link={Link}
                            fundId={fundId}
                            dealId={dealId}/>
                    </Grid>}
             </SubSectionFragment>}
             </SectionFragment>
        )
    }
}

const mapStateToProps = ({ authentication, loan }) => ({
    authentication,
    closedLoans: loan.loansByStatus[loanStatuses.CLOSED_LOAN] ? loan.loansByStatus[loanStatuses.CLOSED_LOAN].loans: null,
    paidOffLoans: loan.loansByStatus[loanStatuses.PAID_OFF] ? loan.loansByStatus[loanStatuses.PAID_OFF].loans : null,
    savedLoan: loan.editLoan && loan.editLoan.data ? loan.editLoan.data : null,
});

export default compose( 
  withRouter,
  connect( mapStateToProps,{addLoan, getLoansByDealIdAndStatus} ),withStyles(styles) ) (LoanView);


  